import { useLocaleStore } from "@/shared/store/localeStore"
import { TRANSLATIONS } from "./translations"

type TranslationTree = (typeof TRANSLATIONS)["en"]

function resolvePath(obj: unknown, path: string): unknown {
  return path.split(".").reduce<unknown>((acc, key) => {
    if (
      acc &&
      typeof acc === "object" &&
      key in (acc as Record<string, unknown>)
    ) {
      return (acc as Record<string, unknown>)[key]
    }
    return undefined
  }, obj)
}

function interpolate(
  template: string,
  params?: Record<string, string | number>
): string {
  if (!params) return template
  return template.replace(/\{(\w+)\}/g, (_, key: string) =>
    String(params[key] ?? "")
  )
}

export function getTranslation(
  path: string,
  locale: keyof typeof TRANSLATIONS
): string {
  const value = resolvePath(TRANSLATIONS[locale] as TranslationTree, path)
  if (typeof value === "string") return value
  return path
}

export function useI18n() {
  const locale = useLocaleStore((s) => s.locale)
  return {
    locale,
    t: (path: string, params?: Record<string, string | number>) =>
      interpolate(getTranslation(path, locale), params),
  }
}

/** Non-hook translation using the active locale from the store (toasts, callbacks outside React). */
export function translatePath(
  path: string,
  params?: Record<string, string | number>
): string {
  const locale = useLocaleStore.getState().locale
  return interpolate(getTranslation(path, locale), params)
}
